import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function RequireRole({ allowed, children }) {
  const { user, activeCompany, authLoading } = useAuth();
  if (authLoading) return null;

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Admin bypasses all role checks
  if (user.role === "admin") return children;

  // If allowed includes "any" — just need to be logged in with a company
  if (allowed.includes("any")) {
    if (activeCompany) return children;
    return <Navigate to="/login" replace />;
  }

  // Check role_in_company
  const companyRole = activeCompany?.role_in_company;
  if (companyRole && allowed.includes(companyRole)) return children;

  return <Navigate to="/login" replace />;
}
